<template>
  <div class="home" id="home-landing">
    <div class="d-block d-md-flex">
      <div class="hero d-flex align-items-center p-0">
        <div class="hero-body">
          <h2 class="fw-bold fs-36 color-blue-2">Start ferien hjemmefra uden stress</h2>
          <p class="fs-14 color-blue-2 mt-3">VALiZO henter din bagage, tjekker dig ind og udleverer boardingkort – hjemme hos dig fra kun 395,- for hele familien</p>
        </div>
      </div>
      <div class="bg-white cta-start">
        <h3 class="fs-30 mb-5 color-blue-2">Start her</h3>
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="d-flex align-items-center mr-3">
            <div class="icon-wrapper">
              <img src="../assets/svg/tickets.svg">
            </div>
            <div class="ml-3">
              <h4 class="fs-22 mb-1 color-blue-2">Personer</h4>
              <h6 class="fs-12 color-blue-2">Boardingkort</h6>
            </div>
          </div>
          <input-number :number="cart.people.length" @setLuggage="setPeopleAmount" @increment="incrementPeople" @decrement="decrementPeople"/>
        </div>
        <div class="d-flex justify-content-between mb-4">
          <div class="d-flex align-items-center mr-3">
            <div class="icon-wrapper">
              <img src="../assets/svg/luggage.svg">
            </div>
            <div class="ml-3">
              <h4 class="fs-22 mb-1 color-blue-2">Kufferter</h4>
              <h6 class="fs-12 color-blue-2">Kufferter, skistøvler og lignende</h6>
            </div>
          </div>
          <input-number :number="cart.luggageSmall.amount" @setLuggage="setProduct('luggageSmall', $event)" @increment="increment('luggageSmall')" @decrement="decrement('luggageSmall')"/>
        </div>
        <div class="d-flex justify-content-between mb-4">
          <div class="d-flex align-items-center mr-3">
            <div class="icon-wrapper">
              <img src="../assets/svg/extras.svg">
            </div>
            <div class="ml-3">
              <h4 class="fs-22 mb-1 color-blue-2">Stor bagage</h4>
              <h6 class="fs-12 color-blue-2">Ski, cykel, golfudstyr og lignende</h6>
            </div>
          </div>
          <input-number :number="cart.luggageLarge.amount" @setLuggage="setProduct('luggageLarge', $event)" @increment="increment('luggageLarge')" @decrement="decrement('luggageLarge')"/>
        </div>
        <div class="d-flex flex-column my-5">
          <input @keyup='validatePostnummer(addressZip)' class="p-3 fs-14" type="text" name="addressZip" placeholder="Postnummer for opsamling" v-model="addressZip">
          <small class='d-none'>Ugyldigt postnummer</small>
          <p class="align-self-end fs-12 color-grey-3 italic mt-2">Servicen gælder på sjælland og Lolland/Flaster</p>
          <h3 class="color-blue-2 fs-24 align-self-end my-4">
            Samlet pris: <span class="fw-semibold">{{ prices.total || 0 }} kr.</span>
            <span v-if="pricing.isLoading" class="pricing-loading">opdaterer...</span>
          </h3>
        </div>
        <span @click.capture="clicked">
            <router-link :to="{ name: 'book', params: { init: true } }" class="bg-blue d-block fs-20 py-4 px-5 color-white font-smoothing position-relative cta-start-btn"
                            :class="'tag-mgr-clickable-step-0 ' + [disableOrder ? 'cursor-not-allowed' : 'cursor-pointer']" :title="titleText">
              Bestil opsamling
              <div class="icon-arrow-right color-white position-absolute h-100 d-flex align-items-center justify-content-center fs-20"></div>
            </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapMutations, mapGetters } from 'vuex'
import InputNumber from '@/components/InputNumber'
import { getPricingSessionId, requestPricingQuote } from '@/services/pricing'

export default {
  name: 'home',
  components: {
    InputNumber,
  },
  computed: {
    ...mapGetters([
      'cart',
      'prices',
      'distributedLuggage',
      'puroadLevel',
      'payment',
      'booking',
      'bookingHome',
      'contact',
      'pricing'
    ]),
    ...mapFields({
      addressZip: 'contact.address.zip',
    }),
    disableOrder() {
      if (/\D/.test(this.addressZip) || this.addressZip.length !== 4 || parseInt(this.addressZip)>=5000  || this.addressZip.substr(0,2)=="37" ||  this.addressZip.substr(0,2)=="39" ) {
        return true;
      } else {
        return false;
      }
    },
    titleText() {
      if (this.disableOrder) return 'Postnummer er påkrævet';
      else return null;
    },
    pricingInputFingerprint() {
      return JSON.stringify({
        people: this.cart.people.length,
        luggageSmall: this.cart.luggageSmall.amount,
        luggageLarge: this.cart.luggageLarge.amount,
        zip: this.addressZip,
        puroadLevel: this.puroadLevel
      })
    }
  },

  data() {
    return {
      pricingDebounceTimer: null,
      pricingRequestCounter: 0,
      pricingSessionId: ''
    }
  },

  mounted() {
    this.pricingSessionId = getPricingSessionId();
    this.setServiceSelection({ serviceUdrejse: true, serviceHjemrejse: false });

    let hash = "#step-0";

    if (this.$route.name === "home"){
      if(this.$route.hash === ""){
        location.hash = this.$route.path + hash;
      } else {
        let new_path = this.$route.path.replace(this.$route.hash,'');
        location.hash = new_path + hash
      }
    }
    this.queuePricingQuote(0);
  },
  beforeDestroy() {
    if (this.pricingDebounceTimer) {
      clearTimeout(this.pricingDebounceTimer);
      this.pricingDebounceTimer = null;
    }
  },
  watch: {
    addressZip (value) {
      if (Number(value) >= this.puroadLevel.maxPostalNumber) {
        this.setPuroadLevelValue(null);
      }
    },
    pricingInputFingerprint() {
      this.queuePricingQuote();
    }
  },
  methods: {
    ...mapMutations([
      'incrementProduct',
      'setProductAmount',
      'decrementProduct',
      'incrementPeople',
      'decrementPeople',
      'setPeople',
      'setPuroadLevelValue',
      'setServiceSelection',
      'setPricingLoading',
      'setPricingQuote',
      'setPricingError'
    ]),
    increment(prop) {
      this.incrementProduct(prop)
    },
    decrement(prop) {
      this.decrementProduct(prop)
    },
    setProduct(prop, amount) {
      this.setProductAmount({ prop, amount })
    },
    setPeopleAmount(amount) {
      this.setPeople(Math.max(1, parseInt(amount, 10) || 1))
    },
    buildPricingPayload() {
      return {
        pricingSessionId: this.pricingSessionId,
        puroadLevel: this.puroadLevel,
        body: {
          cart: {
            ...this.cart
          },
          booking: this.booking,
          bookingHome: this.bookingHome,
          contact: this.contact,
          payment: this.payment
        }
      }
    },
    queuePricingQuote(delay = 250) {
      if (process.env.VUE_APP_PRICING_SOURCE === 'legacy') {
        return;
      }
      if (this.pricingDebounceTimer) {
        clearTimeout(this.pricingDebounceTimer);
      }
      this.pricingDebounceTimer = setTimeout(() => {
        this.refreshPricingQuote();
      }, delay);
    },
    async refreshPricingQuote() {
      if (process.env.VUE_APP_PRICING_SOURCE === 'legacy') {
        return;
      }

      this.pricingRequestCounter += 1;
      const requestId = `home_quote_${this.pricingRequestCounter}`;
      const requestSequence = this.pricingRequestCounter;
      this.setPricingLoading(true);
      this.setPricingError('');

      try {
        const quote = await requestPricingQuote(this.buildPricingPayload());
        if (requestSequence !== this.pricingRequestCounter) {
          return;
        }
        if (quote && quote.success) {
          this.setPricingQuote({
            ...quote,
            requestId
          });
        } else {
          this.setPricingError('quote_failed');
        }
      } catch (error) {
        this.setPricingError('quote_failed');
      } finally {
        this.setPricingLoading(false);
      }
    },
    clicked(e) {
        if(this.disableOrder) e.preventDefault();
        else this.setServiceSelection({ serviceUdrejse: true, serviceHjemrejse: false });

        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 250);
    },
    validatePostnummer(postnummer) {
      if (/\D/.test(postnummer) || postnummer.length !== 4 || parseInt(postnummer)>=5000 || postnummer.substr(0,2)=="37" ||  postnummer.substr(0,2)=="39" ) {
        document.querySelector('input[name=addressZip]').style.border = '1px solid red';
        document.querySelector('small').style.display = 'block';

        const el = document.querySelector('small');
        if (el.classList.contains('d-none')) {
          el.classList.remove('d-none');
        }
      } else {
        document.querySelector('input[name=addressZip]').style.border = '1px solid #E2E2E2';
        document.querySelector('small').style.display = 'none';
      }
    }
  },
}
</script>

<style lang="scss">
  @use 'sass:color';
  @use '../assets/scss/variables' as *;
  @use '../assets/scss/media-queries' as *;

  .hero {
    background: url('../assets/images/bg-front.jpg') center center / cover no-repeat;

    @include min-screen(768px) {
      width: calc(100% - 570px);
    }

    &-body {
      padding: 60px;
      background: rgba(255,255,255,0.9);
      max-width: 440px;

      p {
        max-width: 320px;
      }
    }
  }

  .icon-wrapper {
    width: 50px;
  }

  .cta-start {
    padding: 80px 80px 0;
    box-shadow: 0 10px 50px 0 rgba(47,59,80,0.1);

    @include max-screen(991px) {
      padding: 30px;
    }

    @include min-screen(768px) {
      width: 570px;
    }

    &-btn {
      transition: background .5s ease;

      &:hover {
        text-decoration: none;
        background: color.adjust($blue, $lightness: -4%);
        color: #fff;
      }

      .icon-arrow-right {
        right: 0;
        top: 0;
        width: 80px;
        border-left: 1px solid #2991D8;
      }
    }

    small {
      display: block;
      margin-top: 0.4em;
      color: #ff0000;
    }

    .pricing-loading {
      display: block;
      margin-top: 4px;
      font-size: 11px;
      font-weight: 400;
      color: $grey-3;
      text-align: right;
    }
  }
</style>
